'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () {
                        return e[k];
                    }
                });
            }
        });
    }
    n['default'] = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

const Svg20 = (props) => (React__namespace.createElement("svg", Object.assign({ width: 20, height: 21, viewBox: "0 0 20 21", fill: "none" }, props),
    React__namespace.createElement("g", { clipPath: "url(#20_svg__clip0_39877_64227)" },
        React__namespace.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.3145 2.37836C13.9184 1.9177 13.2239 1.86535 12.7633 2.26141L4.4081 9.44512C4.39668 9.45493 4.38508 9.4649 4.37332 9.47499C4.20002 9.62379 3.99242 9.80203 3.83717 9.97896C3.65095 10.1912 3.41026 10.5429 3.41026 11.0375C3.41026 11.5321 3.65094 11.8837 3.83716 12.096C3.99241 12.2729 4.2 12.4511 4.3733 12.5999C4.38506 12.61 4.39666 12.62 4.40808 12.6298L12.6901 19.7508C13.1508 20.1468 13.8453 20.0945 14.2413 19.6338C14.6374 19.1732 14.5851 18.4787 14.1244 18.0826L5.93057 11.0375L14.1976 3.92959C14.6582 3.53353 14.7106 2.83902 14.3145 2.37836Z", fill: props.fillColor, fillOpacity: 0.92 })),
    React__namespace.createElement("defs", null,
        React__namespace.createElement("clipPath", { id: "20_svg__clip0_39877_64227" },
            React__namespace.createElement("rect", { width: 20, height: 20, fill: "white", transform: "translate(0 0.994873)" })))));

exports.default = Svg20;
//# sourceMappingURL=20.js.map
